import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMailhook(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 10H4v10h16V10h-9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 10 9q0-.424.287-.713A.97.97 0 0 1 11 8h9q.824 0 1.413.588Q22 9.175 22 10v10q0 .824-.587 1.413A1.93 1.93 0 0 1 20 22H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20V10q0-.825.587-1.412A1.93 1.93 0 0 1 4 8h2V3q0-.424.287-.712A.97.97 0 0 1 7 2h6q.424 0 .713.288Q14 2.575 14 3v2q0 .424-.287.713A.97.97 0 0 1 13 6H8v7q0 .424-.287.713A.97.97 0 0 1 7 14a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 13z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
